import { sortBy } from 'lodash';
import config from '~/config';
import http from './http';

const withErrorHandling = async (request) =>{
    try {
        let response = await request();

        if (response.errored) {
            throw new Error(response.error);
        }

        return response;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const addSearchSystem = async (searchSystemName) => {
    const searchSystem = {
        name: searchSystemName
    };

    const uri = `${config.urls.base}/searchSystem`;
    
    return withErrorHandling(() => http.post(uri, searchSystem));
};

export const getSearchSystems = async () => {
    const uri = `${config.urls.base}/searchSystem`;

    const result = await withErrorHandling(() => http.get(uri));
    
    return sortBy(result, [system => system.name.toLowerCase()]);
};

export const updateSearchSystem = async (id, searchSystemName) => {
    const searchSystem = {
        name: searchSystemName
    };

    const uri = `${config.urls.base}/searchSystem/${id}`;
    
    return withErrorHandling(() => http.put(uri, searchSystem));
};

export const deleteSystemSearch = async (id) => {

    const uri = `${config.urls.base}/searchSystem/${id}`;
    
    return withErrorHandling(() => http.del(uri));
};



export default {
    addSearchSystem,
    getSearchSystems,
    updateSearchSystem,
    deleteSystemSearch
};